export const DIV_IDS = 'divIds';
export const DEFAULT_OCR_SCROLL_OFFSET = 400;